import { render, staticRenderFns } from "./skuEdit.vue?vue&type=template&id=54ea5796&scoped=true&"
import script from "./skuEdit.vue?vue&type=script&lang=js&"
export * from "./skuEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ea5796",
  null
  
)

export default component.exports